import styles from "./ImageContentSection.module.css";

const ImageContentSection = ({
  items,
  imageCol = 3,
  contentCol = 9,
  imageMaxWidth = 260,
//   imageHeight = 180,
}) => {
  return (
    <>
      {items.map((item, index) => {
        const bgClass =
          index % 2 === 0 ? styles.sectionBlue : styles.sectionWhite;

        const isList = Array.isArray(item.description);

        return (
          <div key={index} className={bgClass}>
            <div className="container-fluid py-5 px-3 px-md-5">
              <div className="row align-items-center">

                {/* Image */}
                <div
                  className={`col-12 col-md-${imageCol} ${
                    index % 2 === 0
                      ? "text-md-start text-center"
                      : "text-md-end text-center order-md-2"
                  } mb-3 mb-md-0`}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="img-fluid rounded"
                    style={{
                      maxWidth: `${imageMaxWidth}px`,
                    //   height: `${imageHeight}px`,
                      objectFit: "cover",
                      width: "100%",
                    }}
                  />
                </div>

                {/* Content */}
                <div
                  className={`col-12 col-md-${contentCol} ${
                    index % 2 === 0 ? "" : "order-md-1"
                  }`}
                >
                  <h5 className={styles.title}>{item.title}</h5>

                  {!isList ? (
                    <p className={styles.description}>
                      {item.description}
                    </p>
                  ) : (
                    <ul className={styles.list}>
                      {item.description.map((point, i) => (
                        <li key={i}>{point}</li>
                      ))}
                    </ul>
                  )}
                </div>

              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ImageContentSection;
